import React, { FC, ReactElement } from 'react'
import { Switch } from '@/components/ui/switch'
import { Attribute } from '@/utils/types/collections'

const TraitFilterContent: FC<{
	data: Attribute
	onChange: (trait_type: string, filters: string[]) => void
	currentFilters: { values: string[]; trait_type: string }[]
}> = (props): ReactElement => {
	const { data, onChange, currentFilters } = props

	const handleChange = (value: string, checked: boolean) => {
		const currentTraitFilters =
			currentFilters.find((f) => f.trait_type === data.trait_type)?.values || []
		let newFilters: string[]

		if (checked) {
			newFilters = [...currentTraitFilters, value]
		} else {
			newFilters = currentTraitFilters.filter((v) => v !== value)
		}

		onChange(data.trait_type, newFilters)
	}

	// Helper function to capitalize the first letter
	const capitalizeFirstLetter = (string: string) => {
		return string.charAt(0).toUpperCase() + string.slice(1)
	}

	return (
		<div className="space-y-3">
			{' '}
			{/* Added spacing between items */}
			{data.values.map((v, index) => (
				<div key={index} className="flex items-center justify-between">
					<div className="flex items-center gap-x-2">
						<Switch
							id={`${data.trait_type}-${v.value}`}
							checked={currentFilters.some(
								(f) => f.trait_type === data.trait_type && f.values.includes(v.value)
							)}
							onCheckedChange={(checked) => handleChange(v.value, checked)}
						/>
						<label htmlFor={`${data.trait_type}-${v.value}`}>
							{capitalizeFirstLetter(v.value)}
						</label>
					</div>
					<span className="text-sm text-zinc-500">{v.count}</span> {/* Added count */}
				</div>
			))}
		</div>
	)
}

export default TraitFilterContent
